import { render, staticRenderFns } from "./DocumentsDisplay.vue?vue&type=template&id=45165f06&"
import script from "./DocumentsDisplay.vue?vue&type=script&lang=js&"
export * from "./DocumentsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports